<template>
  <Transition name="lvm-transition-x">
    <slot></slot>
  </Transition>
</template>

<style>
.lvm-transition-x-enter-active,
.lvm-transition-x-leave-active {
  transition: all 0.25s ease-out;
}

.lvm-transition-x-enter-from {
  transform: translateX(-30px);
  opacity: 0;
}

.lvm-transition-x-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}
</style>
